<div class="dropdown notification-box">
    <div href="#" class="flex text-decoration-none dropdown-toggle"  id="menu" data-bs-toggle="dropdown" aria-expanded="false">
        <svg *ngIf="!hasUnreadNotification()" width="32" height="32" viewBox="0 0 18 22" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.99992 21.5625C10.1916 21.5625 11.1666 20.5875 11.1666 19.3958H6.83325C6.83325 20.5875 7.80825 21.5625 8.99992 21.5625ZM15.4999 15.0625V9.64583C15.4999 6.32 13.7341 3.53583 10.6249 2.79917V2.0625C10.6249 1.16333 9.89908 0.4375 8.99992 0.4375C8.10075 0.4375 7.37492 1.16333 7.37492 2.0625V2.79917C4.27659 3.53583 2.49992 6.30917 2.49992 9.64583V15.0625L0.333252 17.2292V18.3125H17.6666V17.2292L15.4999 15.0625ZM13.3333 16.1458H4.66658V9.64583C4.66658 6.95917 6.30242 4.77083 8.99992 4.77083C11.6974 4.77083 13.3333 6.95917 13.3333 9.64583V16.1458Z"
                fill="#94A3B8" />
        </svg>
        <svg *ngIf="hasUnreadNotification()" width="32" height="32" viewBox="0 0 26 26" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.0002 23.5625C14.1918 23.5625 15.1668 22.5875 15.1668 21.3958H10.8335C10.8335 22.5875 11.8085 23.5625 13.0002 23.5625ZM19.5002 17.0625V11.6458C19.5002 8.32 17.7343 5.53583 14.6252 4.79917V4.0625C14.6252 3.16333 13.8993 2.4375 13.0002 2.4375C12.101 2.4375 11.3752 3.16333 11.3752 4.0625V4.79917C8.27683 5.53583 6.50016 8.30917 6.50016 11.6458V17.0625L4.3335 19.2292V20.3125H21.6668V19.2292L19.5002 17.0625ZM17.3335 18.1458H8.66683V11.6458C8.66683 8.95917 10.3027 6.77083 13.0002 6.77083C15.6977 6.77083 17.3335 8.95917 17.3335 11.6458V18.1458Z"
                fill="#94A3B8" />
            <circle cx="18" cy="5" r="3.5" fill="#EF4444" stroke="white" />
        </svg>
    </div>
    <div class="dropdown-menu notification-menu" aria-labelledby="menu">
        <div class="notification-card">
            <div class="card-body p-0 notification-info ">
                <div class="info">
                    <div class="body-bold-18 p-0 pb-2 "><span>{{'general.notifications' | translate}}</span></div>
                    <div *ngIf="hasUnreadNotification()">
                        <button class="body-medium-14 p-0 pb-2 blue-500 mark-read-button"
                            (click)="markAllAsRead()">{{'general.mark_all_as_read' | translate}} </button>
                    </div>
                </div>
                <div class="notifications">
                    <div *ngFor="let notification of notifications" (click)="markAsRead(notification)"
                        class="notifiaction" [ngClass]="notification.status==='New'?'new-notification':''">
                        <div *ngIf="notification.userType==='Customer'" class="logo-container">
                            <img [src]="notification?.businessProfile?.avatarPath ? (notification?.businessProfile?.avatarPath | imagePathFormat) : '/assets/vectors/empty_business_service.svg'"
                                [routerLink]="'/business-services/'+notification.businessProfile?.id+'/service/'" alt=""
                                class="customer-profile-photo">
                        </div>
                        <div *ngIf="notification.userType==='Customer'" class="result-info">
                            <div class="info">
                                <div  class="name"
                                    [routerLink]="'/business-services/'+ notification.businessProfile?.id+'/service/'">
                                    <span>{{notification?.businessProfile.businessName}}</span><span
                                        class="body-medium-16">&nbsp;{{'notifications.' + notification.content |
                                        translate}}</span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="secondary">
                                    {{notification.created | dateLocal : 'hh:mm - EEE, MMM d'}}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="notification.userType=='Business'" class="logo-container">
                            <img [src]="notification?.customerProfile?.avatarPath ? (notification?.customerProfile?.avatarPath | imagePathFormat) : '/assets/vectors/empty_business_service.svg'"
                                class="customer-profile-photo">
                        </div>
                        <div *ngIf="notification.userType=='Business'" class="result-info">
                            <div class="info" (click)="navigate(notification)">
                                <div  class="name">
                                    <!-- <span *ngIf="notification?.customerProfile"> {{notification?.customerProfile?.firstName}} &nbsp; {{notification?.customerProfile?.lastName }}</span>
                                    <span *ngIf="notification?.appointment?.guest"> {{notification?.guest?.fullName}}</span> -->
                                    <span
                                        class="body-medium-16">{{'notifications.' + notification.content | translate}}
                                    </span>
                                </div>
                            </div>
                            <div class="info">
                                <div class="secondary">
                                    {{notification.created | dateLocal : 'hh:mm - EEE, MMM d'}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!notifications"><span>{{'general.no_notification' | translate}}</span></div>
                </div>

            </div>

        </div>
    </div>
</div>
